<template>
    <v-flex xs12 mb-4 pt-4 id="seo">
        <v-toolbar text>
            <v-toolbar-title>SEO</v-toolbar-title>
        </v-toolbar>
        <v-layout flex wrap>
            <v-flex xs12>
                <v-subheader class="pa-0">Тайтл</v-subheader>
                <v-text-field
                    ref="title"
                    v-model="seo.title"
                    v-validate="'required|max:50'"
                    data-vv-name="title"
                    :error-messages="errors.collect('title')"
                    single-line
                    text
                    solo
                    required/>
            </v-flex>
            <v-flex xs5>
                <v-subheader class="pa-0">Ключевые слова</v-subheader>
                <v-textarea
                    ref="keywords"
                    v-model="seo.keywords"
                    v-validate="'required|max:60'"
                    data-vv-name="keywords"
                    :error-messages="errors.collect('keywords')"
                    required
                    text
                    solo
                    counter="60"/>
            </v-flex>
            <v-spacer/>
            <v-flex xs5>
                <v-subheader class="pa-0">Описание</v-subheader>
                <v-textarea
                    ref="description"
                    v-model="seo.description"
                    v-validate="'required|max:170'"
                    data-vv-name="description"
                    :error-messages="errors.collect('description')"
                    required
                    text
                    solo
                    counter="170"/>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
    import {Validator} from 'vee-validate'
    export default {
        name: 'seoSite',
        data: () => ({
            dictionary: {
                custom: {
                    title: {
                        required: 'Введите тайтл для сайта',
                        max: 'Превышено максимальное количество символов'
                    },
                    description: {
                        required: 'Описание не заполнено',
                        max: 'Превышено максимальное количество символов'
                    },
                    keywords: {
                        required: 'Ключевые слова не заполнены',
                        max: 'Превышено максимальное количество символов'
                    }
                }
            }
        }),
        props: {
            seo: {
                type: Object,
                default: () => ({
                    title: '',
                    keywords: '',
                    description: ''
                })
            },
            validator: Validator
        },
        created () {
            if (this.validator) {
                this.$validator = this.validator
            }
        },
        mounted () {
            this.$validator.localize('ru', this.dictionary)
            this.$on('veeValidate', () => {
                this.$validator.validateAll()
            })
        }
    }
</script>
